import { SAVE_TECHNICIAN_DATA,// DELETE_TECHNICIAN_DATA 
} from "../Constants";

const initialState = {
  payload: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_TECHNICIAN_DATA:
      return {
        payload: action.data
      };
    default:
      return state;
  }
};
